
import { getSuluPage, fillSeo, handleResponse} from 'razlet-sulu-sdk/lib/utils/helpers';
import Sulu from 'razlet-sulu-sdk/lib/entities/factory';
import {listenGlobalEvent, removeGlobalEvent} from '~/utils/event-handler';

export default {
  name: 'sale',
  layout: 'affiliator',
  async asyncData ({ store, route, error, redirect}) {
    const results = await Promise.allSettled([
      getSuluPage({ store, route, error, redirect }),
    ]);

    const [result] = handleResponse(results, error);
    return {result};
  },
  data() {
    return {
      title: this.$t('sale.title'),
      route: encodeURIComponent(this.$route.hash.substring(2)),
      result: {},
      loading: true,
    };
  },
  created() {
    this.fillSulu(this.result);
  },
  mounted() {
    listenGlobalEvent('success-search', (data) => {
      const route = `variants/${data.detail.uid}?search=${data.detail.search}`;
      this.route = route;
    });
    listenGlobalEvent('back-home', () => {
      this.$router.push('/');
    });
  },
  beforeDestroy() {
    removeGlobalEvent('back-home');
    removeGlobalEvent('success-search');
  },
  methods: {
    fillSulu(res) {
      const suluFactory = new Sulu();
      this.result = suluFactory.create(res);
      this.loading = false;
    },
  },
  head() {
    return {
      ...fillSeo(this, this.result.seo),
    };
  },
};
